export type Faq = { question: string; answer: string[] };

export const faqs: Faq[] = [
  {
    question: "How will I receive the material?",
    answer: ["After your payment is confirmed, you’ll receive instructions for accessing the digital files through the delivery method configured at checkout."],
  },
  {
    question: "Is this suitable for nursing students?",
    answer: [
      "Yes. The collection is designed as an educational reference for nursing students and professionals studying cardiovascular physiology and hemodynamic monitoring.",
      "Some advanced topics may require additional background knowledge.",
    ],
  },
  {
    question: "Is this suitable for experienced ICU nurses?",
    answer: ["Yes. Experienced professionals may use the collection to review selected concepts, revisit physiological relationships, and organize continuing education study sessions."],
  },
  {
    question: "Does the Blueprint™ cover every hemodynamic monitoring topic?",
    answer: ["No. It focuses on selected foundational and advanced hemodynamic monitoring concepts.", "It is not an exhaustive critical care textbook."],
  },
  {
    question: "Can I use this resource to make clinical decisions?",
    answer: [
      "The Blueprint™ is intended for education and professional reference.",
      "It does not provide patient-specific medical advice, establish validated clinical decision algorithms, or replace professional judgment, current evidence, supervised clinical training, institutional protocols, or applicable guidelines.",
    ],
  },
  {
    question: "Do I need to be an ICU specialist?",
    answer: ["No. The collection can also be useful for nursing students and other healthcare professionals interested in studying hemodynamic monitoring."],
  },
  {
    question: "Are the files downloadable?",
    answer: ["The collection is a digital product. Download availability and access instructions depend on the delivery settings shown at checkout."],
  },
  {
    question: "Is this a one-time payment?",
    answer: ["Yes. The introductory offer is $27 USD as a one-time payment.", "There is no monthly subscription associated with this purchase."],
  },
  {
    question: "Can I purchase the Blueprint™ from another country?",
    answer: [
      "Yes. The collection is digital and may be purchased from supported countries. Currency conversion is automatic — your local amount is shown before you pay.",
      "The educational concepts are broadly relevant, but clinical practice requirements, professional regulations, and institutional protocols vary by location.",
    ],
  },
  {
    question: "What happens if the product doesn’t meet my expectations?",
    answer: ["Refund eligibility is governed by the published refund policy.", "The seven-day satisfaction guarantee applies under those terms."],
  },
  {
    question: "Will I receive future updates?",
    answer: ["The purchase includes the materials described in the current offer. Future updates are not guaranteed unless explicitly included in the purchase terms."],
  },
  {
    question: "Can I master hemodynamic monitoring in 15 minutes a day?",
    answer: [
      "The 15-minute format is intended to help you organize focused educational study sessions.",
      "It does not guarantee clinical competency, mastery, or professional certification.",
    ],
  },
];
